export default class Shibboleth {
    classList = {
        active: 'js--active',
        loading: 'js--loading-wrapper',
        updateInstitutionEntity: 'ghaith',
    };

    content = {
        loadingEL:
            '<div class="js--loading-wrapper" role="alert"><div class="js--loading"></div><div class="sr-only">loading institution list</div></div>',
        contentLoadedEL: '<div role="alert">institution list loaded</div>',
    };

    selectors = {
        institutions: '.institutions',
        institution: '.institution-list',
        federationSelect: '.federation-select',
        federationSelectContent: '.federation-select__content',
        federationSelectContentLi: 'li[data-index-target]',
        loading: '.js--loading-wrapper',
        federationAlert: '.federation-alert',
    };

    elements = {
        institutions: null,
        federationSelect: null,
        federationSelectContent: null,
        federationSelectContentLi: null,
        federationAlert: null,
    };

    constructor() {
        this.elements.sction = document.querySelector('.shibboleth');
        this.setElements();
        this.eventListeners();
        this.onReady();
    }

    setElements() {
        this.elements.institutions = this.elements.sction.querySelector(this.selectors.institutions);
        this.elements.federationSelect = this.elements.sction.querySelector(this.selectors.federationSelect);
        this.elements.federationSelectContent = this.elements.sction.querySelector(
            this.selectors.federationSelectContent
        );
        this.elements.federationSelectContentLi = this.elements.federationSelectContent.querySelectorAll(
            this.selectors.federationSelectContentLi
        );
        this.elements.federationAlert = this.elements.sction.querySelector(this.selectors.federationAlert);
    }

    onReady() {}

    eventListeners() {
        this.elements.federationSelect.addEventListener('change', this.selectChangeHandlers);
        this.elements.federationSelectContent.addEventListener('click', this.updateInstitutionEntity);
    }

    selectChangeHandlers = e => {
        const selectedIndex = e.target.selectedIndex,
            selectedLi = this.elements.federationSelectContent.querySelector(
                `li[data-index-target="${selectedIndex}"]`
            ),
            selectedLiContent = selectedLi?.querySelector(this.selectors.institution),
            currentLi = this.elements.federationSelectContent.querySelector(`li.js--active[data-index-target]`),
            getFederationsLink = '/pb/widgets/shibboleth/getFederationInstitutions?federation=',
            redirectUri = this.findGetParameter('redirectUri');

        currentLi?.classList.remove(this.classList.active);
        selectedLi.classList.add(this.classList.active);

        if (!selectedLiContent && selectedLi.dataset.indexTarget !== '0') {
            this.showLoading();
            // return
            const link = `${getFederationsLink}${encodeURIComponent(e.target.value)}${
                redirectUri !== null ? `&redirectUrl=${redirectUri}` : ''
            }`;
            fetch(link)
                .then(response => response.json())
                .then(data => {
                    selectedLi.insertAdjacentHTML('beforeend', this.createInstitutionsList(data));
                    this.hideLoading();
                });
        }
    };

    updateInstitutionEntity = e => {
        if (
            e.target.classList.contains(this.classList.updateInstitutionEntity) ||
            e.target.parentElement.classList.contains(this.classList.updateInstitutionEntity)
        ) {
            e.preventDefault();

            let targetEl = e.target.classList.contains(this.classList.updateInstitutionEntity)
                    ? e.target
                    : e.target.parentElement,
                updateEntityData = JSON.parse(targetEl.dataset.updateentity),
                linkData = targetEl.dataset.link;

            SeamlessAccessService.updateEntity(updateEntityData)
                .then(function (res) {
                    if (linkData !== undefined) {
                        window.location.href = linkData;
                    }
                })
                .catch(function (err) {
                    if (linkData !== undefined) {
                        console.log(err); // eslint-disable-line no-console
                        window.location.href = linkData;
                    }
                });
        }
    };

    createInstitutionsList = data => {
        let items = '',
            i = 0;

        for (i = 0; i < data.length; i++) {
            const itemData = data[i],
                entityData = {
                    entityID: itemData.entityId,
                    title: itemData.name,
                },
                entityDataStr = JSON.stringify(entityData).replace(/'/g, '&apos;');

            items += `
                <li data-value="${itemData.name}">
                    <a class="ghaith" data-entityid="${itemData.entityId}" data-name="${itemData.entityId}" data-updateEntity='${entityDataStr}' data-link="${itemData.url}" href="javascript:void(0)">
                        ${itemData.name}
                    </a>
                </li>
            `;
        }
        return `<ul id="institution-${i}" class="institution-list">${items}</ul>`;
    };

    findGetParameter = parameterName => {
        let result = null,
            tmp = [];
        location.search
            .substr(1)
            .split('&')
            .forEach(function (item) {
                tmp = item.split('=');
                if (tmp[0] === parameterName) result = tmp[1];
            });
        return result;
    };

    showLoading = () => this.elements.institutions.insertAdjacentHTML('afterbegin', this.content.loadingEL);

    hideLoading = () => {
        const loadingEL = this.elements.institutions.querySelector(this.selectors.loading);
        if (loadingEL) {
            loadingEL.remove();
            this.elements.federationAlert.innerHTML = this.content.contentLoadedEL;
            setTimeout(() => {
                this.elements.federationAlert.innerHTML = '';
            }, 3000);
        }
    };
}
